export default __webpack_public_path__ + "static/media/espelhos_decorativos.a7260918.jpg";